// extracted by mini-css-extract-plugin
module.exports = {"login":"LoginAuth_login__23j82","btn":"LoginAuth_btn__2VVNM","login_form":"LoginAuth_login_form__3Un-j","login_input":"LoginAuth_login_input__1QIjr"};